module.exports = __webpack_public_path__ + "static/media/CQ6Poster.2fee8743.jpeg";